import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * 共通404画面
 * @returns
 */
const NotFound = () => {
  return (
    <Box
      sx={{
        width: "100%",
        textAlign: "center",
      }}
    >
      <Typography variant="h2">404</Typography>
      <Typography>ページが存在しない</Typography>
    </Box>
  );
};
export default NotFound;
